module.exports = __webpack_public_path__ + "static/media/claudia_miranda.32b8608b.jpg";